import { Component, OnInit, ChangeDetectorRef} from '@angular/core';
import { states } from "../../../../../constants/Global";
import { Observable } from "rxjs";
import { PopupService } from "../../../../../services/popup.service";
import { MyStuffService } from "../../../../../services/my-stuff.service";
import { PinTypeEnum } from "../../../../../enums/PinTypeEnum";
import { environment } from '../../../../../../environments/environment';
import { LoaderService } from '../../../../../services/loader.service';
import { RemovedItemsService } from "../../../../../services/removed-items.service";

@Component({
  selector: 'app-all-removed-items',
  templateUrl: './all-removed-items.component.html',
  styleUrls: ['./all-removed-items.component.less']
})
export class AllRemovedItemsComponent implements OnInit {

  constructor(public popupService: PopupService, public myStuffService: MyStuffService,
              public ref: ChangeDetectorRef, public loaderService : LoaderService, public removedItemsService : RemovedItemsService) { }

  states = states;
  GOOGLE_CLIENT_ID = environment.APP.GOOGLE_CLIENT_ID;
  API_URL = environment.APP.API_URL;

  ngOnInit() {
    if(this.popupService.popupList.popups['my-stuff'] && !this.myStuffService.myStuffSectionOpened.allDeleted) {
      this.removedItemsService.fetchAllRemovedItemsSource.next(true);
      this.myStuffService.myStuffSectionOpened.allDeleted = true;
    }
  }

  ngAfterViewInit() {
    this.removedItemsService.allRemovedItemsAddInputEventObservable();
  }

  getPinType(type) {
    if(type === PinTypeEnum.LABEL) {
      return 'label';
    } else if(type === PinTypeEnum.DOT) {
      return 'dot';
    } else if(type === PinTypeEnum.PIN) {
      return 'pin';
    } else if(type === PinTypeEnum.PIN_LABEL) {
      return 'pin with label';
    }
  }

  applyWidth(item) {
    if(item.logoPinImage && item.logoPinImage.url && item.logoPinImage.originalWidth && item.logoPinImage.originalHeight) {
      if(item.logoPinImage.originalWidth >= item.logoPinImage.originalHeight) {
        return true;
      }
    } else if(item.smallPinImage && item.smallPinImage.url && item.smallPinImage.originalWidth && item.smallPinImage.originalHeight) {
      if(item.smallPinImage.originalWidth >= item.smallPinImage.originalHeight) {
        return true;
      }
    }
    return false;
  }

  applyHeight(item) {
    if(item.logoPinImage && item.logoPinImage.url && item.logoPinImage.originalWidth && item.logoPinImage.originalHeight) {
      if(item.logoPinImage.originalWidth < item.logoPinImage.originalHeight) {
        return true;
      }
    } else if(item.smallPinImage && item.smallPinImage.url && item.smallPinImage.originalWidth && item.smallPinImage.originalHeight) {
      if(item.smallPinImage.originalWidth < item.smallPinImage.originalHeight) {
        return true;
      }
    }
    return false;
  }

  paginate() {
    this.removedItemsService.fetchAllRemovedItems();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/popups/my-stuff/removed-items/all-removed-items/all-removed-items.component.ts